<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout row wrap>
        <v-flex xs12>
          <v-select v-model="inputSource" :items="inputSources" label="Input" />
          <v-expansion-panels id="panelMetricTab" multiple>
            <v-expansion-panel
              v-for="(metricTab, matricIndex) in activeMetricTabs"
              :id="`assessment_metric_${matricIndex}`"
              :key="metricTab.id"
            >
              <v-expansion-panel-header>
                <div>
                  {{ metricTab.name }}
                  <v-chip class="ma-2" color="green">{{ metricTab.metrics.length }}</v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-stepper v-show="metricTab.metrics.length > 0" v-model="e6" vertical>
                  <div
                    v-for="(metric, index) in metricTab.metrics"
                    :id="`${metric.id}_local_metric_${index}`"
                    :key="`${metric.id}_local_metric_${index}`"
                  >
                    <assessment-step
                      :metric="metric"
                      :index="index"
                      :assessment="currentAssessment"
                      @next="e6 = (e6 + 1)"
                    />
                  </div>
                </v-stepper>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn id="buttonComplete" color="success" @click="complete">Save and Complete</v-btn>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  map, uniq, filter, find, flatten,
} from 'lodash';
import AssessmentStep from '../components/AssessmentStep';

import formatting from '../mixins/formatting';

export default {
  mixins: [formatting],
  components: {
    AssessmentStep,
  },
  data() {
    return {
      assessment: null,
      frequencies: ['Monthly', 'Quarterly', 'Annual'],
      e6: 0,
      inputSource: 'All',
      filters: ['All'],
    };
  },
  computed: {
    ...mapState('assessments', ['currentAssessment']),
    ...mapState('metricTabs', ['metricTabsWithMetrics']),
    ...mapState('odata', ['assessmentItems']),
    activeMetricTabs() {
      const { currentAssessment, inputSource } = this;
      const tabs = Object.assign({}, this.metricTabsWithMetrics);
      const result = map(tabs, (t) => {
        const tab = Object.assign({}, t);
        tab.metrics = map(tab.metrics, (m) => {
          const metric = Object.assign({}, m);
          metric.assessmentItem = find(currentAssessment.assessmentItems, a => a.metricId === m.id);
          return metric;
        });
        tab.metrics = filter(tab.metrics, m => m.when === currentAssessment.frequency);
        if (inputSource && inputSource !== 'All') {
          tab.metrics = filter(tab.metrics, m => m.inputSource === inputSource);
        }
        return tab;
      });
      return filter(result, r => r.metrics.length > 0);
    },
    inputSources() {
      // const { currentAssessment } = this;
      const tabs = Object.assign({}, this.activeMetricTabs);
      // const result = map(tabs, (t) => {
      //   const tab = Object.assign(t);
      //   tab.metrics = map(tab.metrics, (m) => {
      //     const metric = Object.assign(m);
      //     metric.assessmentItem = find(currentAssessment.assessmentItems, a => a.metricId === m.id);
      //     return metric;
      //   });
      //   tab.metrics = filter(tab.metrics, m => m.when === currentAssessment.frequency);
      //   return tab;
      // });
      const metrics = flatten(map(tabs, am => am.metrics));
      const r = uniq(map(metrics, 'inputSource')).sort();
      r.unshift('All');
      return r;
    },
    title() {
      return `Assessment for ${this.getClient(this.assessment.clientId)} started ${this.formatFromNow(this.assessment.created)}`;
    },
  },
  mounted() {
    this.loadMetricTabsWithMetrics();
    // this.$store.dispatch('odata/load.assessmentItem', this.$route.params.id);
    this.loadAssessment(this.$route.params.id);
  },
  methods: {
    ...mapActions('assessments', ['startAssessment', 'loadAssessment', 'resetCurrentAssessment']),
    ...mapActions('metricTabs', ['loadMetricTabsWithMetrics']),
    complete() {
      this.$root.$confirm('Are you sure you want to complete this assessment?').then((confirm) => {
        if (confirm) {
          this.$store.dispatch('odata/update.assessment', {
            id: this.currentAssessment.id,
            isCompleted: true,
            completed: new Date(),
          }).then(() => {
            this.$router.push({ path: '/assessments' });
          });
        }
      });
    },
  },
};
</script>
